 <template>
	<div id="app">
		<Header v-if="show_header" />
		<transition name="fade" mode="out-in">
			<router-view v-on:showFooter="showFooter" v-on:changeFooter="changeFooter" v-on:showHeader="showHeader"  class="router" ref="router"></router-view>
		</transition>
		<portal-target name="global-layer"></portal-target>
		<Footer ref="footer" v-if="show_footer" :footer_style="footer_style" />
	</div>
</template>
<script>
import { getOssToken, getSetting,RecordVisit } from "@/api/index.js";
import Footer from "@/components/Footer.vue";
import Header from "@/components/Header.vue";
import util from '@/utils/util';
import localStorage from "@/utils/localStorage.js";
	export default {
		components: {
			Header,
			Footer
		},
		data() {
			return {
				show_header: true,
				show_footer: true,
				footer_style:'light'
			};
		},
		methods: {
			changeFooter(style){
				console.log('changefooter',style);
				this.footer_style = style;
			},
			showHeader(bool) {
				this.show_header = bool;
			},
			showFooter(bool) {
				this.show_footer = bool;
			},
			async getOssToken() {
				let json = await getOssToken()
				this.$store.commit('setAliYunOSS',json.data)
			},
			async initSetting() {
				getSetting({}).then(response => {
					let link = document.querySelector("link[rel*='icon']") || document.createElement('link');
					link.type = 'image/x-icon';
					link.rel = 'shortcut icon';
					link.href = response.data.favicon;
					document.getElementsByTagName('head')[0].appendChild(link);
					// document.title = response.data.document_title
					// console.log('response.data',response.data);
					this.$store.commit("updateSetting", response.data)
				})
				getSetting({code:'user',key:'system'}).then(response => {
					this.$store.commit("updateUserTaskSetting", response.data)
				})
				
			},
			async setVisitor() {
				let visitorId = localStorage.get('visitor_id')
				  if (!visitorId) {
					visitorId = util.uuid() // 生成唯一ID
					localStorage.set('visitor_id',visitorId)
				}
				RecordVisit({
					channel_code:this.$store.state.channel,
					visitor_id:visitorId
				})
			},
		},
		created() {
			this.getOssToken()
			this.initSetting()
			this.setVisitor()
		}
	};
</script>
<style lang="scss">
@font-face{
	font-family: 'MicrosoftYaHei';
	src:url('https://img.hongli.xingjuju.com/yichuanghub/fonts/MicrosoftYaHei.ttf') format('truetype');
}
@font-face{
	font-family:'Comfortaa-Medium';
	src:url('https://img.hongli.xingjuju.com/yichuanghub/fonts/Comfortaa-Medium.ttf') format('truetype');
}
@font-face{
	font-family:'BebasNeue-Regular';
	src:url('https://img.hongli.xingjuju.com/yichuanghub/fonts/BebasNeue-Regular.ttf') format('truetype');
}
@font-face{
	font-family:'BebasNeue-Bold';
	src:url('https://img.hongli.xingjuju.com/yichuanghub/fonts/BebasNeue-Bold.ttf') format('truetype');
}
@font-face{
	font-family:'SourceHanSansSC';
	src:url('https://img.hongli.xingjuju.com/yichuanghub/fonts/SourceHanSansSC.ttf') format('truetype');
}
html,body{
	display:inline-block;
	align-items:center;
	text-align:center;
	width:100%;
	max-width:100vw;
	// min-width:1279px;
	// max-width:1920px;
	min-height:100vh !important;
	margin:0 auto;
}
#app {
	/* font-family: PingFang SC; */
	// font-family: 'MicrosoftYaHei','微软雅黑' !important;
	width:100%;
	min-width:1279px;
	max-width:1910px;
	position:relative;
	min-height:100vh;
	text-align:left !important;
	align-self: center;
	margin:0 auto !important;
	// .router{
	// 	width:100%;
	// 	display:flex;
	// 	flex-wrap:wrap;
	// }
}

	.cursor {
		cursor: pointer;
	}
</style>
